import { Outlet, Route } from 'react-router-dom'
import { WalletContext } from '~/components/WalletContext'

import { TradePage } from './TradePage'

/** Mounted at /trade, deliberately not /marketplace.
 *
 *  `features/marketplace` already owns that path: it is the Magic Eden browser
 *  that shows what BR1 NFTs fetch elsewhere and hands the user off to pay in
 *  SOL. This is the BR1-native one, settled in BR1 balance. Two live paths for
 *  now; when this replaces the other, the route moves and the old feature goes. */
export const TradeRoutes = [
    <Route
        key='trade'
        element={
            // Not global: deposit and lootbox wrap themselves too. Without this
            // `useWallet()` is an inert default whose `publicKey` is always null,
            // so nothing on this page could ever connect or sign.
            <WalletContext>
                <Outlet />
            </WalletContext>
        }
    >
        <Route index element={<TradePage />} />
    </Route>,
]
